import React from "react"
import styled from "styled-components"

import ListTitle from "./ListTitle"
import ListContent from "./ListContent"

const StyledListItem = styled.li`
  margin-block: 2.4rem;
  margin-inline-start: 1rem;
`
export default function ListItem({ title, content, content2 = null }) {
  return (
    <StyledListItem>
      <ListTitle title={title} />
      <ListContent content={content} content2={content2} />
    </StyledListItem>
  )
}
